import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3ZM20.5,16a1,1,0,0,1,0,2H18.25a.25.25,0,0,0-.25.25V20.5a1,1,0,0,1-2,0V18.25a.25.25,0,0,0-.25-.25H13.5a1,1,0,0,1,0-2h2.25a.25.25,0,0,0,.25-.25V13.5a1,1,0,0,1,2,0v2.25a.25.25,0,0,0,.25.25ZM2,3A1,1,0,0,1,3,2H21a1,1,0,0,1,.43.1.24.24,0,0,1,.14.18.26.26,0,0,1-.07.22l-19,19a.26.26,0,0,1-.22.07.24.24,0,0,1-.18-.14A1,1,0,0,1,2,21Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M5.5,7.5H11a1,1,0,0,0,0-2H5.5a1,1,0,0,0,0,2Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }